"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCORDION_CONTENT_CLASS = exports.BcAccordionConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BC_ACCORDION = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion");
var BcAccordionConstants = (function () {
    function BcAccordionConstants() {
    }
    BcAccordionConstants.BC_ACCORDIONS_GROUPS_SUFIX = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordions-group");
    BcAccordionConstants.BC_ACCORDION_CLASS = BC_ACCORDION;
    BcAccordionConstants.BC_ACCORDION_SINGLE_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-single");
    BcAccordionConstants.BC_ACCORDION_ACTIVE_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-active");
    BcAccordionConstants.BC_ACCORDION_CONTENT_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-content");
    BcAccordionConstants.BC_ACCORDION_HEADER = "header";
    return BcAccordionConstants;
}());
exports.BcAccordionConstants = BcAccordionConstants;
exports.ACCORDION_CONTENT_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-content");
